//h5配置信息
import { inDev, getSStorageInfo } from '@/common'

const currentSource = getSStorageInfo('source') || '0016000100000000'
let anyCharUrl = ''
const isDev = process.env.NODE_ENV !== 'production'

// if (currentSource == '0016000100000000') {
//   anyCharUrl = inDev
//     ? 'https://livetest.jzsec.com/AnyChat/h5/'
//     : 'https://live.jzsec.com/AnyChat/h5/'
// } else {
//   anyCharUrl = inDev
//     ? 'https://livetest.jzsec.com:8941/AnyChat/h5/'
//     : 'https://live.jzsec.com:8941/AnyChat/h5/'
// }
anyCharUrl = inDev
  ? 'https://qwapitest.jzsec.com:8941/AnyChat/h5/'
  : 'https://live.jzsec.com:8941/AnyChat/h5/'
const win = window as any
win.anyChat_H5_deploy = {
  // loginIp: "unicenter.kingstarfintech.com",
  // loginPort: '8443/anyChat/',
  // loginAppId: 'B71CD67A-2A7A-504F-92C1-0305CE9C9AF6',
  // videoPathPrefix: 'https://unicenter.kingstarfintech.com:8443/anychat/anychatfiles/record/'

  // loginIp: "dev.bairuitech.cn",
  // loginPort: '14607',
  // loginIp: "dev.bairuitech.cn",
  // loginPort: '16005',
  // loginAppId: '00A4B0B4-ECBF-5B4A-A65E-91FC22F59BD1',
  // videoPathPrefix:''

  // loginIp: 'livetest.jzsec.com',
  loginIp: inDev ? 'qwapitest.jzsec.com' : 'live.jzsec.com',
  loginPort: '8940',
  loginAppId: '',
  // videoPathPrefix: 'https://livetest.jzsec.com:8941/AnyChat/h5/',
  videoPathPrefix: anyCharUrl,
  // inDev
  //   ? 'https://livetest.jzsec.com:8941/AnyChat/h5/'
  //   : 'https://live.jzsec.com:8941/AnyChat/h5/',

  // loginIp: "h5kh.bairuitech.cn",
  // loginPort: '8915',
  // loginAppId: 'A6F7CDB6-0613-0B4C-9A0B-CF72A67EB0DD',
  // videoPathPrefix:'https://h5kh.bairuitech.cn:10443/h5sl/'
}

// anychat活体验证地址
win.anyChat_H5_living_action = `${anyCharUrl}index.html#/idr_living_action`
// inDev
//   ? 'https://livetest.jzsec.com:8941/AnyChat/h5/index.html#/idr_living_action'
//   : 'https://live.jzsec.com:8941/AnyChat/h5/index.html#/idr_living_action'

// anychat单向认证地址
// ;(window as any).anyChat_H5_idr = 'https://livetest.jzsec.com:8941/AnyChat/h5/index.html#/idr'
// win.anyChat_H5_idr = inDev
//   ? 'https://livetest.jzsec.com:8941/AnyChat/h5/index.html#/idr'
//   : 'https://live.jzsec.com:8941/AnyChat/h5/index.html#/idr'
win.anyChat_H5_idr = `${anyCharUrl}index.html#/idr`
